<script setup lang="ts">
    import AcademyTrainingsCarouselView from '~/storyblok/AcademyTrainingsCarousel/AcademyTrainingsCarouselView.vue';
    import type { RelatedTrainingsMode } from '~/types/academy/courseRelations';

    const {
        courseId,
        mode = 'same_catalog',
        headline = '',
        relatedCourseIds = []
    } = defineProps<{
        courseId: string;
        mode?: RelatedTrainingsMode;
        headline?: string;
        relatedCourseIds?: number[];
    }>();

    const {
        items: carouselItems,
        isInitialLoading,
        prettyError,
        isAuthenticated,
        hasValidCourseId
    } = useAcademyRelatedTrainings(
        () => courseId,
        () => mode,
        () => relatedCourseIds
    );
    const { isDraftModeEnabled } = useDraftMode();
    const previewNotice = computed(() => {
        if (!isDraftModeEnabled.value) return null;
        if (!isAuthenticated.value) return 'academy.relatedTrainings.previewLoginRequired';
        if (!hasValidCourseId.value) return 'academy.relatedTrainings.previewCourseRequired';
        if (prettyError.value) return 'academy.relatedTrainings.previewLoadError';
        return null;
    });
</script>

<template>
    <Note
        v-if="previewNotice"
        :type="prettyError && isAuthenticated && hasValidCourseId ? 'error' : 'warning'"
    >
        {{ $t(previewNotice) }}
    </Note>
    <AcademyTrainingsCarouselView
        v-else-if="isInitialLoading || carouselItems.length > 0"
        :headline="headline"
    >
        <template
            v-if="$slots.teaser"
            #teaser
        >
            <slot name="teaser" />
        </template>

        <AcademyTrainingsCarouselClientContent
            :pretty-error="prettyError"
            :items="carouselItems"
            :show-no-results="false"
            :no-results-message="''"
            :is-initial-loading="isInitialLoading"
        />

        <template
            v-if="$slots.link"
            #link
        >
            <slot name="link" />
        </template>
    </AcademyTrainingsCarouselView>
</template>
